import type { YammerState } from '@ms/yammer-data/dist/state/types';

import { repairToken } from './repairToken';

type SetupTokenRepair = (state: YammerState) => void;
export const setupTokenRepair: SetupTokenRepair = (state: YammerState) => {
  window.addEventListener('focus', () => repairToken(state));
};
